/**
 * Created by ximing on 2019-03-01.
 */

import React, { useState } from "react"
import { graphql, StaticQuery, Link } from "gatsby"
import Image from "gatsby-image"

function Header() {
  const [showMenu, toggleMenu] = useState(false)

  return (
    <StaticQuery
      query={headerQuery}
      render={(data) => {
        const { author } = data.site.siteMetadata
        return (
          <header id="header">
            <Link
              style={{
                boxShadow: `none`,
                textDecoration: `none`,
                color: `inherit`,
                marginRight: 20,
              }}
              to={`/`}
            >
              <Image
                style={{
                  marginBottom: 0,
                  minWidth: 50,
                  borderRadius: `100%`,
                }}
                imgStyle={{
                  borderRadius: `50%`,
                }}
                fixed={data.avatar.childImageSharp.fixed}
                alt={author}
              />
              {/*<GatsbyImage*/}
              {/*  style={{*/}
              {/*    marginBottom: 0,*/}
              {/*    minWidth: 50,*/}
              {/*    borderRadius: `100%`,*/}
              {/*  }}*/}
              {/*  imgStyle={{*/}
              {/*    borderRadius: `50%`,*/}
              {/*  }}*/}
              {/*  image={data.avatar.childImageSharp.gatsbyImageData}*/}
              {/*  alt={author}*/}
              {/*/>*/}
            </Link>
            <div id="nav">
              <div id="title" style={{ marginBottom: 8 }}>
                <h1>{author}</h1>
              </div>
              <button onClick={() => toggleMenu(!showMenu)}>
                <i className="fa fa-bars fa-2x" />
              </button>
              <ul className={showMenu ? "responsive" : ""}>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/think/">Think</Link>
                </li>
                {/* <li>
                  <Link to="/video/">Video</Link>
                </li> */}
                <li>
                  <Link to="/tags/">Tags</Link>
                </li>
                <li>
                  <Link to="/about/">About</Link>
                </li>
                <li>
                  <a
                    href="http://github.com/ximing"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Github
                  </a>
                </li>
              </ul>
            </div>
          </header>
        )
      }}
    />
  )
}

const headerQuery = graphql`
  query HeaderQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
        #        gatsbyImageData(layout: FIXED, width: 50, height: 50, formats: [JPG])
      }
    }
    site {
      siteMetadata {
        author
        social {
          github
        }
      }
    }
  }
`

export default Header
